<template>
  <div class="users-page">
    <div class="users-header">
      <h2 class="title">Users</h2>
      <button type="button" class="button is-primary is-small" @click="addUser">
        Add user
      </button>
    </div>

    <table class="table is-striped is-narrow is-hoverable is-fullwidth users-table">
      <thead>
        <tr>
          <th>Username</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td>{{ user.username }}</td>
          <td class="email-cell">
            <span class="user-email">{{ user.email }}</span>
            <button
              type="button"
              class="button is-danger is-small remove-button"
              @click="removeUser(user.id)"
            >
              <i class="fa fa-trash"></i>
              Remove
            </button>
          </td>
        </tr>
        <tr v-if="users.length === 0">
          <td colspan="2" class="has-text-centered">No users found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ALL_USERS_QUERY } from '@/graphql'

export default {
  name: 'Users',
  data () {
    return {
      users: []
    }
  },
  apollo: {
    // fetch all users
    users: {
      query: ALL_USERS_QUERY,
      error (errorDetails) {
        if (errorDetails.message.includes('Authentication Failure') || errorDetails.message.includes('Signature has expired')) {
          localStorage.removeItem('app-token')
          this.$router.push('/login')
        }
      }
    }
  },
  methods: {
    addUser () {
      this.$router.push('/signup')
    },
    removeUser (userId) {
      if (!window.confirm('Remove this user?')) return
      console.warn('removeUser not implemented yet for user id:', userId)
      // TODO: wire removeUser to backend mutation and refresh list
    }
  }
}
</script>
<style scoped>
.users-page {
  padding: 2rem;
}

.users-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.users-table th,
.users-table td {
  vertical-align: middle;
}

.email-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.user-email {
  display: inline-block;
  word-break: break-word;
  max-width: calc(100% - 110px);
}

.remove-button {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Users.vue